import {
  FETCH_ADSETS,
  SET_ADSET,
  CLEAR_ADSETS_STATE
} from './mutations-types'
import Adsets from '../../../facebook/Adsets'
import helpers from '../../../helpers/functions'

export default {
  fetchAdsets ({ commit, dispatch }) {
    commit(CLEAR_ADSETS_STATE)
    let user = helpers.getCurrentUser()
    const adsets = new Adsets(user)
    return new Promise((resolve, reject) => {
      resolve(adsets.fetchAdsets())
    })
      .then(res => {
        commit(FETCH_ADSETS, res.data)
        commit(SET_ADSET, res.data[0])
      })
      .catch(err => {
        const error = JSON.parse(err.message)
        const response = error.response || {}
        let identifier
        if (response.error_subcode) identifier = response.error_subcode
        else if (response.message) identifier = response.message
        helpers.handleError(error, identifier, 'Facebook: ')
      })
  },
  setAdset ({ commit }, payload) {
    commit(SET_ADSET, payload)
  }
}
